/* tslint:disable */
/* eslint-disable */
/**
 * FastAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Schema for creating a lesson.
 * @export
 * @interface LessonCreate
 */
export interface LessonCreate {
    /**
     * 
     * @type {string}
     * @memberof LessonCreate
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof LessonCreate
     */
    topic?: string | null;
    /**
     * 
     * @type {string}
     * @memberof LessonCreate
     */
    description?: string | null;
    /**
     * 
     * @type {number}
     * @memberof LessonCreate
     */
    order?: number;
    /**
     * 
     * @type {string}
     * @memberof LessonCreate
     */
    tutorial_id?: string | null;
}

/**
 * Check if a given object implements the LessonCreate interface.
 */
export function instanceOfLessonCreate(value: object): value is LessonCreate {
    if (!('name' in value) || value['name'] === undefined) return false;
    return true;
}

export function LessonCreateFromJSON(json: any): LessonCreate {
    return LessonCreateFromJSONTyped(json, false);
}

export function LessonCreateFromJSONTyped(json: any, ignoreDiscriminator: boolean): LessonCreate {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'],
        'topic': json['topic'] == null ? undefined : json['topic'],
        'description': json['description'] == null ? undefined : json['description'],
        'order': json['order'] == null ? undefined : json['order'],
        'tutorial_id': json['tutorial_id'] == null ? undefined : json['tutorial_id'],
    };
}

export function LessonCreateToJSON(json: any): LessonCreate {
    return LessonCreateToJSONTyped(json, false);
}

export function LessonCreateToJSONTyped(value?: LessonCreate | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': value['name'],
        'topic': value['topic'],
        'description': value['description'],
        'order': value['order'],
        'tutorial_id': value['tutorial_id'],
    };
}

